
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic/[urlSlug]",
      function () {
        return require("private-next-pages/topic/[urlSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic/[urlSlug]"])
      });
    }
  